export const defaultTimeSpans = [
  {
    span: "INTRADAY",
    label: "1D",
    active: true
  },
  {
    span: "FIVE_DAYS",
    label: "5D",
    active: false
  },
  {
    span: "ONE_MONTH",
    label: "1M",
    active: false
  },
  {
    span: "THREE_MONTHS",
    label: "3M",
    active: false
  },
  {
    span: "SIX_MONTHS",
    label: "6M",
    active: false
  },
  {
    span: "YTD",
    label: "YTD",
    active: false
  },
  {
    span: "ONE_YEAR",
    label: "1Y",
    active: false
  },
  {
    span: "THREE_YEARS",
    label: "3Y",
    active: false
  },
  {
    span: "FIVE_YEARS",
    label: "5Y",
    active: false
  },
  {
    span: "TEN_YEARS",
    label: "10Y",
    active: false
  },
  {
    span: "MAX",
    label: "MAX",
    active: false
  }
];
